import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import RegisterShipmentCalculatorComponent from '../../components/registerShipmentCalculator';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	componentId: number;
	page: IPageViewModel;
}

const RegisterShipmentCalculator: FC<Props> = ({ page }) => {
	const { t } = useTranslation('registerShipment');
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">
				{t('calculator.calculate-price')}
			</H1>
			<RegisterShipmentCalculatorComponent />
		</Container>
	);
};

export default pageWrapper(RegisterShipmentCalculator);
